export default "__VITE_ASSET__TZAW4UZF__"